import { get, post } from '../utils/FetchV2.util';

/** An arm frozen in `user_experiments` (heru-user-management-engine). */
export type ExperimentAssignment = {
	/** The GrowthBook feature key, verbatim. */
	experiment_id: string;
	variation_id: number;
	variation_value?: unknown;
	assigned_at: string;
};

export type ExperimentAssignmentBody = Pick<
	ExperimentAssignment,
	'experiment_id' | 'variation_id' | 'variation_value'
>;

export const getExperimentAssignmentsService = async (): Promise<
	ExperimentAssignment[]
> => {
	const response = await get<{ assignments: ExperimentAssignment[] }>({
		service: 'userManagementEngine',
		endpoint: '/experiments/web/assignments',
	});
	return response?.assignments ?? [];
};

/** First write wins: returns the arm that RULES, not the one sent. */
export const assignExperimentService = (body: ExperimentAssignmentBody) =>
	post<ExperimentAssignment>({
		service: 'userManagementEngine',
		endpoint: '/experiments/web/assign',
		body,
		skipAccountError: true,
	});

/** Overwrites the arm. The back only accepts it from internal/QA accounts (403). */
export const overrideExperimentService = (body: ExperimentAssignmentBody) =>
	post<ExperimentAssignment>({
		service: 'userManagementEngine',
		endpoint: '/experiments/web/override',
		body,
		skipAccountError: true,
	});
